import { Subject } from "rxjs";
import {isEmpty} from 'services/global';
import * as workerTimers from 'worker-timers';

export function countdownToPreDraft() {
    const subject = new Subject();

    const countdownPreDraftDate = new Date("September 28, 2026 20:30:00").getTime();
    
    const interval = setInterval(() => {
        var now = new Date().getTime();
        var distance = countdownPreDraftDate - now;
        var preDraftDate;

        if(distance < 0) {
            preDraftDate = 'now';
            subject.next(preDraftDate);
            clearInterval(interval);
            subject.complete();
            return subject;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        preDraftDate = days + "d " + hours + "h " + minutes + "m " + seconds + "s";

        if(days <= 0 && hours > 0) {
            preDraftDate = hours + "h " + minutes + "m " + seconds + "s";
        }
        else if(days <= 0 && hours <= 0) {
            if(minutes < 10) {
                minutes = ("0" + minutes);
            }
            if(seconds < 10) {
                seconds = ("0" + seconds);
            }
            preDraftDate = minutes + ":" + seconds;
        }

        //if draft day has finally come, t minus 20 mins, clear the interval and set the date to null
        if ((days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) || subject.isStopped) {
            preDraftDate = 'now';
            //need to send subject.next() here or else preDraftDate would be stuck at 1 second instead of 'now'
            subject.next(preDraftDate);
            clearInterval(interval);
            subject.complete();
        }
        subject.next(preDraftDate);
    }, 100);

    return subject;
}

export function countdownToActualDraft() {
    const subject = new Subject();

    const countDownDate = new Date("September 28, 2026 20:45:00").getTime();
    
    const interval = setInterval(() => {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var actualDraftDate;

        //2 hours from the draft start time.
        if(distance < -7200000) {
            actualDraftDate = 'completed';
            subject.next(actualDraftDate);
            clearInterval(interval);
            subject.complete();
            return subject;
        }
        else if(distance < 0) {
            actualDraftDate = 'now';
            subject.next(actualDraftDate);
            clearInterval(interval);
            subject.complete();
            return subject;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        actualDraftDate = days + "d " + hours + "h " + minutes + "m " + seconds + "s";

        if(days <= 0 && hours > 0) {
            actualDraftDate = hours + "h " + minutes + "m " + seconds + "s";
        }
        else if(days <= 0 && hours <= 0) {
            if(minutes < 10) {
                minutes = ("0" + minutes);
            }
            if(seconds < 10) {
                seconds = ("0" + seconds);
            }
            actualDraftDate = minutes + ":" + seconds;
        }

        //if draft day has finally come, t minus 20 mins, clear the interval and set the date to null
        if ((days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) || subject.isStopped) {
            actualDraftDate = 'now';
            //need to send subject.next() here or else actualDraftDate would be stuck at 1 second instead of 'now'
            subject.next(actualDraftDate);
            clearInterval(interval);
            subject.complete();
        }
        subject.next(actualDraftDate);
    }, 100);

    return subject;
}

export function draftTimer(draftTimerNewTime) {
    const subject = new Subject();

    //draft's over!
    if(draftTimerNewTime === 'draft_complete') {
        subject.next('draft_complete');
        subject.complete();
        return subject;
    }
    if(isEmpty(draftTimerNewTime) || draftTimerNewTime === 'completed') {
        return subject;
    }

    //3 mins for a pick, so to start off, make it 3 mins after the start of the draft
    const countDownDate = new Date(draftTimerNewTime).getTime();

    const interval = workerTimers.setInterval(() => {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var timeLeft;

        if(distance < 0) {
            timeLeft = 'expired';
            //need to send subject.next() here or else time would be stuck at 1 second
            subject.next(timeLeft);
            workerTimers.clearInterval(interval);

            //make the auto pick and reset the interval to 3 mins
            subject.complete();
            return subject;
        }

        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if(seconds >= 0 && seconds < 10) {
            seconds = "0" + seconds;
        }
        timeLeft = minutes + ":" + seconds;

        if ((minutes <= 0 && seconds <= 0) || subject.isStopped) {
            timeLeft = 'expired';
            //need to send subject.next() here or else time would be stuck at 1 second
            subject.next(timeLeft);
            workerTimers.clearInterval(interval);

            //make the auto pick and reset the interval to 3 mins
            subject.complete();
        }
        subject.next(timeLeft);
    }, 100);

    return subject;
}